import './expo_page.css';
import React from 'react';


function Legend() {
return (
    <div>
        <div className="home-title">
        <h1>Manuali & Legende</h1>
        </div>
        <br />
        <div className="geo-container">
        <div className="tools">
        <section className="py-12 text-left">
        <div className="container mx-auto">
        <p>
        <strong>Ultimo aggiornamento:</strong> 19/08/2025
        </p>

        <p>
        In questa pagina sono raccolte manuali e legende di ciascuna regione.
        </p>


        <h2 className="text-im mt-6">Regione Emilia-Romagna</h2>
        <p className="text-gray-600 mt-2">
        I dati geografici sono forniti dal <strong>Geoportale della Regione Emilia-Romagna</strong>.
        </p>
        <ul className="text-gray-600 mt-2 list-disc list-inside">
        <li>
        Legenda: <a href="//" target="_blank" rel="noopener noreferrer">NULL</a>
        </li>
        </ul>

        <h2 className="text-im mt-6">Regione Lombardia</h2>
        <p className="text-gray-600 mt-2">
        I dati geografici sono forniti dal <strong>Geoportale della Lombardia</strong>.
        </p>
        <ul className="text-gray-600 mt-2 list-disc list-inside">
        <li>
        Legenda: <a href="https://www.cartografia.servizirl.it/caspita/legenda/Legenda_si.pdf" target="_blank" rel="noopener noreferrer">apri</a>
        </li>
        </ul>


        <p className="text-gray-600 mt-6">
        Ulteriori regioni e fonti verranno elencate qui man mano che i dati saranno integrati.
        </p>
        </div>
        </section>
        </div>
        </div>
        </div>
        );
    }


export default Legend;




